module.exports = "https://coursera_assets.s3.amazonaws.com/images/d936e11fa3884b8c9f1bd5c914be8629.png";